<template>
  <div class="news">
      <NewsList :newsLength="5" />
  </div>
</template>
<script>
import NewsList from '@/components/newsList';
export default {
  name:'news',
  components:{
    NewsList,
  }
}
</script>
<style lang="scss">
    @import '@/style/variables.scss';
  .news{
    width:$navWidth;
    padding:0 20px;
    margin:20px auto;
    background:#fff;
    border-radius: 5px;
  }
  
</style>
